import { LocationObject } from '@pflegia/types/common/location/location-object';

import { EmployerType } from '../employer/employer-type';

export enum SalaryCalculatorExperienceLevel {
  ZeroToOne = 'zero_to_one',
  TwoToSix = 'two_to_six',
  SevenToFourteen = 'seven_to_fourteen',
  FifteenPlus = 'fifteen_plus',
}

export const SALARY_CALCULATOR_EXPERIENCE_FACTORS: Record<SalaryCalculatorExperienceLevel, number> = {
  [SalaryCalculatorExperienceLevel.ZeroToOne]: 0.92,
  [SalaryCalculatorExperienceLevel.TwoToSix]: 0.98,
  [SalaryCalculatorExperienceLevel.SevenToFourteen]: 1.06,
  [SalaryCalculatorExperienceLevel.FifteenPlus]: 1.16,
};

export const SALARY_CALCULATOR_EXPERIENCE_LABELS: Record<SalaryCalculatorExperienceLevel, string> = {
  [SalaryCalculatorExperienceLevel.ZeroToOne]: '0-1',
  [SalaryCalculatorExperienceLevel.TwoToSix]: '2-6',
  [SalaryCalculatorExperienceLevel.SevenToFourteen]: '7-14',
  [SalaryCalculatorExperienceLevel.FifteenPlus]: '15+',
};

export const SALARY_CALCULATOR_EXPERIENCE_LEVELS = Object.values(SalaryCalculatorExperienceLevel);

export const SALARY_CALCULATOR_FULL_TIME_HOURS = 40;
// eslint-disable-next-line no-magic-numbers
export const SALARY_CALCULATOR_PART_TIME_HOURS = [10, 20, 30] as const;
export const SALARY_LANDING_TOP_LOCATIONS_LIMIT = 5;
export const SALARY_LANDING_TOP_POSITIONS_LIMIT = 6;
export const DEFAULT_PART_TIME_HOURS = 20;

export type SalaryCalculatorPartTimeHours = (typeof SALARY_CALCULATOR_PART_TIME_HOURS)[number];

export interface SalaryCalculatorEstimation {
  dataPoints: number;
  highSalary: number;
  lowSalary: number;
  medianSalary: number;
  usedFallback: boolean;
}

export interface SalaryCalculatorQueryInput {
  employerType: EmployerType;
  experienceLevel: SalaryCalculatorExperienceLevel;
  jobTitleId: string;
  location: LocationObject;
  workingHours: number;
}
